<template>
  <ur-modal
    ref="modal"
    noFoot
    width="704px;"
    title="계정 삭제"
    @closed="clear">
    <div class="modal">
      <div class="modal_dialog">
        <div class="modal_content modal_sm delete_user_pop">
          <div class="modal_body">
            <p class="txt_desc type2 mt0">
              계정을 정말로 삭제하시겠습니까?<br />
              영구적으로 계정을 삭제하기 위해 비밀번호를 입력해주세요.
            </p>
            <div class="tbl_list type2">
              <table>
                <colgroup>
                  <col style="width: 167px" />
                  <col style="width: auto" />
                </colgroup>
                <tbody>
                  <tr>
                    <th scope="row">비밀번호</th>
                    <td>
                      <ur-text-field
                        type="password"
                        v-model="password"
                        placeholder="비밀번호"
                        @keyup.enter="onClickDeleteUser"
                        width="90%"
                        ref="password"
                      />
                      <br/>
                      <span v-if="isPasswordError" class="error">{{this.deleteReturnMsg}}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal_footer">
            <ur-button @click="showPasswordCheck">취소</ur-button>
            <ur-button :disabled="isDisabledBtn" @click="onClickDeleteUser" main>삭제</ur-button>
          </div>
        </div>
      </div>
    </div>
    <ur-modal ref="successModal" :title="'알림'" small @closed="gotoLoginPage()">
        <template>
          {{successMessage}}
        </template>
        <template slot="action">
          <ur-button shape="solid" primary @click="gotoLoginPage()">확인</ur-button>
        </template>
      </ur-modal>
  </ur-modal>
</template>

<script>

import AuthManager from "~system/auth/AuthManager";

export default {
  data() {
    return {
      password: "",
      userDeleteAsk: {
        password: "",
      },
      isPasswordError: false,
      deleteReturnMsg: "",
      successMessage :'',
    };
  },
  computed: {
    isDisabledBtn() {
      if (this.password.length === 0) {
        return true;
      }
      return false;
    },
  },
  methods: {
    open() {
      this.$refs["modal"].open();
    },
    close() {
      this.$refs["modal"].close();
    },
    clear() {
      this.isPasswordError = false;
      this.password = "";
      },
    showPasswordCheck() {
      this.isPasswordError = false;
      this.password = "";
      this.close();
    },
    gotoLoginPage() {
      this.$store.state.isLoggedIn = false;
      this.$router.go();
    },
    opensuccessModal(message) {
      this.successMessage = message;
      this.$refs.successModal.open();
    },
    onClickDeleteUser() {
      this.isPasswordError = false;
      // 평문 비밀번호를 암호화
      AuthManager.encrypt(this.password).then((encryptedPassword) => {
        const login = {
          encryptedPassword,
        };
        this.userDeleteAsk.encryptedPassword = encryptedPassword;
        this.userDeleteAsk.loginType = sessionStorage.getItem("loginType");
        return new Promise((resolve, reject) => {
          http
            .request(this.contextPageId, "DTS_CMP_00140", {
              data: this.userDeleteAsk,
            })
            .then((response) => {
              if (response.data.reply.code === "5100") {
                this.$store.state.isLoggedIn = false;
                this.opensuccessModal(response.data.reply.korMsg);
              } else {
                this.deleteReturnMsg = response.data.reply.korMsg;
                this.isPasswordError = true;
              }
            })
            .catch((err) => {
              console.error(err);
            });
        });
      });
    },
  },
};
</script>
<style scoped>
span.error{
  left: 0;
  bottom: 12px;
  font-size: 12px;
  line-height: 1;
  color: #db352e;
}
</style>